import { render, staticRenderFns } from "./ui-pagination.vue?vue&type=template&id=6e7c5322"
import script from "./ui-pagination.vue?vue&type=script&lang=js"
export * from "./ui-pagination.vue?vue&type=script&lang=js"
import style0 from "./ui-pagination.vue?vue&type=style&index=0&id=6e7c5322&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports